import React, { useState } from "react";
import { useSelector } from "react-redux";
import { APPLICATION_STATUS_PENDING_PAYMENT } from "../../../../app/constants";
import { CollectorDetails } from "./Collectors/CollectorDetails";
import { CollectorsTable } from "./Collectors/CollectorsTable";

export const CollectorsTab = (props) => {
    const { licenceApplication, applicationType, applicationMode, showApplicationType } = props;

    const collectors = useSelector(state => state.additionalApplications.agentApplications.filter(app => app.applicationStatus !== APPLICATION_STATUS_PENDING_PAYMENT))
    const [collector, setCollector] = useState()


    return collector 
    ? <CollectorDetails 
        collector={collector} 
        licenceApplication={licenceApplication} 
        setCollector={setCollector} 
        applicationType={applicationType} 
        applicationMode={applicationMode} 
    />
    : <CollectorsTable 
        collectors={collectors} 
        licenceApplication={licenceApplication} 
        applicationType={applicationType} 
        applicationMode={applicationMode} 
        setCollector={setCollector} 
        showApplicationType={showApplicationType}
    />
}
